import identity from 'transmute/identity';
import { fetchConditionalPropertyOptionsRules } from '../../v2/conditionalPropertyOptionsRules/api';
import { InMemoryCache } from '../InMemoryCache';
export const makeConditionalPropertyOptionsRulesCache = () => new InMemoryCache('ConditionalPropertyOptionRulesCache', fetchConditionalPropertyOptionsRules, identity);